function getUrlTemplateToUse(urlTemplate, router) {
  if (!urlTemplate) return urlTemplate;

  if (urlTemplate.startsWith('../')) {
    const currentPath = router.asPath.split('/');
    currentPath.pop();
    const newPath = currentPath.join('/');
    return `${newPath}/${urlTemplate.replace('../', '')}`;
  }

  if (!urlTemplate.startsWith('/')) return `${router.asPath}/${urlTemplate}`;

  return urlTemplate;
}

export default getUrlTemplateToUse;
